var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconNotCopyPaste48Line = function SvgIconNotCopyPaste48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m39.2 36.8-28-28-2.4 2.4 3 3V31h3.4V17.6l2.63 2.64V33.4a5.31 5.31 0 0 0 5.3 5.3h7.8a5.249 5.249 0 0 0 3.78-1.62l2.09 2.12 2.4-2.4Zm-8.3-1.5h-7.8a1.9 1.9 0 0 1-1.9-1.9v-9.8l11.09 11.09a1.91 1.91 0 0 1-1.39.61ZM28.5 12.7V9.3H17.1a5.081 5.081 0 0 0-1.24.16l3.24 3.24h9.4ZM21.86 15.46l3.24 3.24h5.8a1.9 1.9 0 0 1 1.9 1.9v5.8l3.4 3.4v-9.2a5.31 5.31 0 0 0-5.3-5.3h-7.8a5.081 5.081 0 0 0-1.24.16Z",
    fill: "current"
  })));
};
export default SvgIconNotCopyPaste48Line;